import type { InternalAxiosRequestConfig } from "axios";
import axios from "axios";

export function getServiceApiKey(): string {
  const k = process.env.VUE_APP_SERVICE_API_KEY;
  return typeof k === "string" ? k.trim() : "";
}

export function initializeGlobalServiceApiKeyHeader(): void {
  const key = getServiceApiKey();
  if (!key) {
    return;
  }

  axios.defaults.headers.common["x-api-key"] = key;
}

export function applyServiceApiKeyToAxiosConfig(
  config: InternalAxiosRequestConfig
): void {
  const key = getServiceApiKey();
  if (!key) {
    return;
  }

  config.headers = config.headers ?? {};
  const h = config.headers as Record<string, string>;
  h["x-api-key"] = key;
}
